import { useNavigate } from 'react-router-dom';
import { MailQuestion } from 'lucide-react';
import type { FollowupRow } from '@/lib/crm-client';
import { formatDate } from '@/lib/utils';
import { ListenKarte } from './ListenKarte';

/**
 * Erstansprachen, auf die niemand geantwortet hat und bei denen ein
 * Nachfassen ansteht.
 *
 * `gesamt` kommt aus dem Digest statt aus der geladenen Liste — die ist auf
 * sechs Zeilen begrenzt und wüsste sonst nicht, wie viele noch dahinter
 * liegen.
 */
export function FollowupsCard({
  followups,
  gesamt,
}: {
  followups: FollowupRow[];
  gesamt: number;
}) {
  const navigate = useNavigate();

  return (
    <ListenKarte
      titel="Nachfassen fällig"
      icon={MailQuestion}
      mehr={{ label: 'Alle Erstansprachen', onClick: () => navigate('/akquise?reiter=freigaben') }}
      leer="Nichts nachzufassen."
      gesamt={gesamt}
      gezeigt={followups.length}
    >
      {followups.map((f) => (
        <li key={f.messageId}>
          <button
            onClick={() => navigate('/akquise?reiter=freigaben')}
            className="flex w-full items-start gap-3 px-4 py-2.5 text-left transition-colors hover:bg-muted/40"
          >
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium">
                {f.contactName ?? f.contactEmail ?? 'Unbekannt'}
                {f.organizationName && (
                  <span className="font-normal text-muted-foreground">
                    {' · '}
                    {f.organizationName}
                  </span>
                )}
              </p>
              <p className="truncate text-xs text-muted-foreground">
                {f.subject || '(ohne Betreff)'}
              </p>
            </div>
            <span className="mt-0.5 shrink-0 text-xs text-muted-foreground">
              {f.step === 0 ? 'angeschrieben' : `${f.step}. Nachfassen`}
              {' · '}
              {formatDate(f.sentAt)}
            </span>
          </button>
        </li>
      ))}
    </ListenKarte>
  );
}
